import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=62f5a804&scoped=true"
import script from "./DialogConfirm.vue?vue&type=script&lang=js"
export * from "./DialogConfirm.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=62f5a804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5a804",
  null
  
)

export default component.exports